import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Input } from "../../../../Input/Input";
import { Textarea } from "../../../../Input/Textarea";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../BlackListModal/BlackListModal";
import { DeleteModalLabel } from "../CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../CommentModal/CommentModal";
import { ModalLabel } from "../CommentModal/TargetContainer";
import { ErrorMessage } from "../../../../Login/LoginErrorMessage";

interface SubphoneEditModalProps extends DefaultModalCommonProps {
  viewData: {
    user: string;
  };
}

export default function SubphoneInputModal({
  closeEvent,
  confirmEvent,
  viewData,
}: SubphoneEditModalProps) {
  const [newSubPhone, setNewSubPhone] = useState("");
  const [reason, setReason] = useState("");
  const [alert, setAlert] = useState(false);
  const [execute, setExecute] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: execute ? `user/subphone` : undefined,
    data: {
      uid: Number(viewData?.user?.split("_")[0] ?? 0),
      phone: newSubPhone.replaceAll("-", ""),
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("보조 연락처를 등록했습니다.");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "보조 연락처 등록에 실패했습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => setAlert(true)}
      modalTitle="보조 연락처 등록"
      isMediumModal={true}
      confirmDisabled={reason === ""}
    >
      <>
        <ModalRow style={{ marginBottom: 0 }}>
          <ModalLabel>보조 연락처 입력</ModalLabel>

          <ModalRowContentContainer>
            <Input
              placeholder="'-' 제외하고 입력해 주세요."
              value={newSubPhone}
              onChange={(e) => setNewSubPhone(e.target.value)}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={11}
            />
          </ModalRowContentContainer>
        </ModalRow>

        <NotiDesc>
          <span className="material-icons-outlined">info</span>
          보조 연락처 값을 입력하지 않으면, 보조 연락처가 삭제됩니다.
        </NotiDesc>

        <DeleteModalLabel>등록 사유</DeleteModalLabel>

        <Textarea
          placeholder="등록 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
        />

        {alert && (
          <AlertModal
            title={"보조 연락처를 등록하시겠습니까?"}
            cancelEvent={() => setAlert(false)}
            confirmEvent={() => setExecute(true)}
            btnColor="mint"
          />
        )}

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}

const NotiDesc = styled(ErrorMessage)`
  margin-top: 10px;
  margin: 10px 0 20px 0;
  color: #858c97;
`;
